/// <reference path="../common/type-info.d.ts" />
import '../common/type-info'
import * as mobx from 'mobx'
import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'
import Queue from 'promise-queue'

import {Libs} from 'eyes-lib/es'

const {registToGlobal} = Libs

/** 状態変更モード never:どこからでも | observed: 厳密モード | always: アクション指定 */
mobx.configure({enforceActions: 'always'})
// mobx.configure({enforceActions: 'never'})

/** コンテキストパスとアプリケーションパス */
const pathInfo = (()=>
{
	/** lodashのtrimは第二引数が秀逸！前後の`/`削ってから`/`でsplit */
	const paths = _.trim( Libs.urlInfo().pathname, '/' ).split('/')
	const contextName = _.get(paths, 0, '')
	const appName = _.get(paths, 1, '')
	const restPath = _.drop(paths, 2).join('/')
	return {
		/** サーバーコンテキスト名 */
		CONTEXT_NAME: contextName,

		/** サーバーコンテキストパス */
		CONTEXT_PATH: `/${contextName}`,

		/** サーバーアプリケーション名 */
		APP_NAME: appName,

		/** サーバーアプリケーションパス */
		APP_PATH: `/${appName}`,

		/** コンテキスト＋アプリケーションのパス */
		SYSTEM_PATH: `/${contextName}/${appName}`,

		/** 残りのパス情報 */
		REST_PATH: `/${restPath}`,
	}
})()

/** アプリケーションとして保持したい値や基本機能のテンプレートオブジェクト */
const baseApp = _.merge( pathInfo, {
	/**
	 * HTML5-History-API polyfill
	 * @type {Location}
	 */
	location: _.get(window, 'history.location', window.location),

	/** @type {boolean} */
	isDevelop: false,

	/**
	 * テンプレート保管用
	 */
	template: new Libs.Template(),

	/**
	 * セッションストレージ読み書き用
	 * @description 有効期限 12時間
	 */
	session: new Libs.Store({
		storage: sessionStorage,
		namespace: pathInfo.SYSTEM_PATH,
		expireMs: 1000*60*60*12,
	}),

	/**
	 * 有効期限ほぼなしのセッションストレージ
	 */
	permanentSession: new Libs.Store({
		storage: sessionStorage,
		namespace: `##${pathInfo.SYSTEM_PATH}`,
		expireMs: 1000*60*60*24*365
	 }),

	/**
	 * ローカルストレージ読み書き用
	 * @description 有効期限 4ヶ月後
	 */
	storage: new Libs.Store({
		storage: localStorage,
		namespace: pathInfo.SYSTEM_PATH,
		expireMs: moment().add(4, 'month').diff( moment() )
	}),

	/**
	 * Promiseキュー
	 */
	queue: new Queue(1, 1000),

	/**
	 * グローバル変数的に使うデータ用オブジェクト
	 */
	data: {
		/** ヘッダフッタコード */
		headercd: '',
		/** BtoBtoC代理店コード */
		agentcd: '',
		/** BtoB代理店コード */
		unitcd: '',
		// /** 営業所コード */
		// branch_cd: [],
		/**
		 * バリデーターモジュールインスタンス
		 * @type {parsley.Form}
		 */
		form: null,
	},
	version: `0.8.1`,
})

/**
 * アプリケーションとして保持したい値や基本機能
 * @description pathInfoとミックスインさせてます
 */
const App = Object.freeze( baseApp )

/** APPはどこでも使えるようにGlobal変数に登録する */
registToGlobal('App', App)

/**
 * モデルオブジェクトを拡張する
 * @template T
 * @param {T} model
 */
const extendModel = function(model){
	return Object.seal( _.extend({
		/**
		 * 新しいインスタンスを生成する
		 */
		new: function(){
			/** newプロパティがないと型チェックですぐ怒られるので生やしておく */
			return _.merge({new: _.get(this, 'new')}, model)
		}
	}, model ))
}

/**
 * DOM状態オブジェクト合成
 * @description DOM状態オブジェにextendModelのnewを混入させないため
 * @param {import('./store').SearchDomState} dom
 */
function domStateMerge(dom, ...stats) {
	_.each( stats, stat => Libs.deepUnset(stat, 'new') )

	mobx.runInAction( '状態オブジェクト合成', () =>
	{
		_.merge.apply(null, [dom].concat(stats) )

		/** tmp系はここで加工して入れ込む */
		_.each(dom, (ignore, key) => {
			if( key.startsWith('tmp_') )
			{
				const srcKey = key.substr(4)
				const srcVal = _.get(dom, srcKey )
				_.set( dom, key, srcVal )
			}
		} )
	})
}


/**
 * 商品クラス
 */
const Shohin = extendModel({

	/** 出発日日本語 */
	from_date:"",

	/** 到着日日本語 */
	to_date:"",

	/** 商品コード */
	shohin_code:"",

	/** 商品名 */
	shohin_name:"",

	/** 商品サブタイトル */
	shohin_subtitle:"",

	/** 合計料金 */
	total_price:0,

})

/**
 * 旅客区分クラス
 */
const Passenger = extendModel({
	/** 旅客区分コード */
	passenger_code:"",

	/** 旅客区分名 */
	passenger_name:"",

	/** 旅客人数 */
	passenger_count:0,

	/**
	 * 旅客タイプ 0:大人 1:小人 2:幼児
	 * @type {0|1|2|"0"|"1"|"2"}
	 */
	passenger_paxtype: null,

	/** 添い寝フラグ 0:通常, 1:添い寝 */
	passenger_soineflag:"0",

	/** 0円許可フラグ 0:通常 1:0円許可 */
	passenger_base0flag: 0

})

/**
 * 部屋種別クラス
 */
const RoomPax = extendModel({
	/** 部屋種別コード */
	roomclass_code: "",

	/** 部屋種別名 */
	roomclass_name: "",

	/** 部屋種別数 */
	roomclass_count: 0,

	/** 部屋種別コメント */
	roomclass_comment: "",

	/** @type {import("./store").Passenger[]} 旅客情報 */
	passenger:[],
})

/**
 * 便クラス
 */
const BinData = extendModel({

	/** 便コード */
	bin_code: "",

	/** 便名 */
	bin_name: "",

	/** 便グループコード 予約で使用 */
	bing_code:"",

	/** 利用日 予約で使用 */
	bord_date:"",

	/** 便タイプ 予約で使用 */
	bin_type:"",

	/** 便種別 予約で使用 */
	type_flag:0,

	/** 詳細SEQ 予約で使用 */
	bin_seq:0,

	/** 乗下車地選択フラグ */
	allot_flag:"",

	/** 0:往路 1:復路 */
	oufuku_flag:0,

	/** リクエストフラグ */
	rq_flag:0,

	/** 出発到着地 */
	/** @type {import("./store").DepArrData[]} 出発到着地情報 */
	deparr:[],

})

/**
 * ホテルクラス
 */
const HotelData = extendModel({

	/** ホテルグループコード */
	hotelgroup_code:"",

	/** ホテルコード */
	hotel_code:"",

	/** ホテル名 */
	hotel_name:"",

	/** プランコード */
	hotelplan_code:"",

	/** プラン名 */
	hotelplan_name:"",

	/** 部屋種別コード */
	roomclass_code:"",

	/** 詳細SEQ 予約で使用 */
	hotel_seq:0,

	/** @type {import("./store").RoomPax[]} 部屋情報*/
	room: [],

	/** 宿泊日 */
	use_date:"",

	/** 宿泊数 */
	haku:0,

	/** ROOMPAXCD */
	roompax_code:""
})


/**
 * 出到着地情報
 */
const DepArrData = extendModel({
	/** 出発地コード */
	dep_code:"",

	/** 出発地名 */
	dep_name:"",

	/** 到着地コード */
	arr_code:"",

	/** 到着地名 */
	arr_name:"",

	/** 旅客情報 */
	/** @type {import("./store").Passenger[]} 旅客情報 */
	passenger:[],

})

/**
 * セットオプションクラス
 */
const OtherSetData = extendModel({

	/** オプション名 */
	other_name:"",

	/** セットコード */
	set_code:"",

	/** セット名 */
	set_name:"",

	/** グループコード */
	grp_code:"",

	/** 利用日 */
	stdate:1,

	/** 旅客情報 */
	/** @type {import("./store").Passenger[]} 旅客情報 */
	passenger:[],

});

/**
 * オプショングループクラス
 */
const OtherData = extendModel({

	/** オプション名 */
	other_name:"",

	/** オプショングループコード */
	otherg_code:"",

	/** オプショングループ名 */
	otherg_name:"",

	/** SEQ */
	seq:0,

	/** 利用日 */
	stdate:1,

	/** リクエストフラグ */
	rq_flag:0,

	/** 旅客情報 */
	/** @type {import("./store").Passenger[]} 旅客情報 */
	passenger:[],

});


/**
 * カート情報
 */
const CartData = extendModel({

	uniqueId:"",

	/** 料金区分 */
	priceCategory:"",

	/**@type {import("./store").Shohin} 商品情報*/
	shohin:null,

	/** @type {import("./store").RoomPax[]} 部屋情報*/
	room: [],

	/** @type {import("./store").Passenger[]} 旅客情報 */
	passenger:[],

	/** @type {import("./store").BinData[]} 便情報*/
	bin:[],

	/** @type {import("./store").HotelData[]} ホテル情報*/
	hotel:[],

	/** @type {import("./store").OtherSetData[]} セットオプション情報*/
	otherset:[],

	/** @type {import("./store").OtherData[]} オプショングループ情報*/
	othergrp:[],

	/** @type {import("./store").OtherData[]} オプション情報*/
	other:[],

	/**@type {import("./store").Login} ログイン*/
	login:null,

	/**@type {import("./store").Person} お客様情報*/
	person:null,

	/**@type {import("./store").UserChoose} お客様情報*/
	userchoose:null,

	price: 0,

	/** 帰着日延長 */
	extend_count:0,
	
})

/**
 * 商品詳細クラス
 */
const DetailData = extendModel({

	/** 商品コード */
	tourcode:"",

	/** 営業所コード */
	branchcode:"",

	/** タイトル */
	title:"",

	/** サブタイトル */
	subtitle:"",

	/** 泊数日数(単位付き) */
	termday:"",

	/** 最低料金(カンマ整形済) */
	minprice:"",

	/** 最高料金(カンマ整形済) */
	maxprice:"",

	/** 画像パス */
	tourimage:"",

	/** ヘッダーコード */
	headercode:"",


})

/**
 * お気に入りカート情報
 */
const FavoriteCartData = extendModel({

	/** @type {import("./store").DetailData[]} 商品情報*/
	favorite: [],

})


/**
 * 検索用商品
 * @description VSCodeならDBのデータソース
 * (Create文のコメント部分)から簡単にコメントとプロパティが構築可能
 */
const TempSearchShohin = extendModel({
	/** ヘッダフッタコード */
	header_cd:'',

	/** 商品コード1 */
	code1:'',

	/** 商品コード2 */
	code2:'',

	/** 商品コード3 */
	code3:'',

	/** 営業所コード */
	branchcd:'',

	/** 代理店コード */
	agent: '',

	/** パンフレットコード */
	pamphletcd: '',

	/** 料金用日付 */
	sdate:'',

	/** 最小料金 */
	minprice: 0,

	/** 最大料金 */
	maxprice: 0,

	/** 種別 0:国内 1:海外 2:訪日 3:スキー（※未使用） */
	interflag:'',

	/** 旅行形態 0：募集型 1：受注型 2：手配旅行 3:物販 */
	travelflag:'',

	/** 団体・個人 0:個人旅行 1:団体旅行 */
	tourflag:'',

	/** ツアー名 */
	name:'',

	/** サブタイトル */
	subtitle:'',

	/** 〇泊 */
	webhaku: 0,

	/** 〇日 */
	webday: 0,

	/** 受付可能日FROM */
	ukefrom:'',

	/** 受付可能日TO */
	uketo:'',

	/** 出発可能日FROM */
	kikanfrom:'',

	/** 出発可能日TO */
	kikanto:'',

	/** 出発地文字列 */
	fromtoshi:'',

	/** 到着地文字列 */
	totoshi:'',

	/** 交通機関文字列 */
	traffic:'',

	/** アイコン文字列[区切り文字//] */
	icon:'',

	/** 宿泊素材文字列[区切り文字//] */
	hotel:'',

	/** 検索画像パス */
	kensakuimage: ''
})

/** 商品画像 */
const ShohinImage = extendModel({
	seq: 0,
	remarks: '',
	filename: '',
})


/**
 * お客様情報クラス
 */
const Person = extendModel({
	/** 顧客コード */
	person_custcd: "",

	/** お名前（漢字）姓 */
	person_sei: "",

	/** お名前（漢字）名 */
	person_mei: "",

	/** フリガナ（全角）セイ */
	person_kanasei: "",

	/** フリガナ（全角）メイ */
	person_kanamei: "",

	/** ローマ字（半角英字）SEI */
	person_alphasei: "",

	/** ローマ字（半角英字）MEI */
	person_alphamei: "",
	
	/** 旅券番号（半角英数字）*/
	person_passportno: "",
	
	/** パスポート受領予定日*/
	person_pptdate: "",
	
	/** 国籍*/
	person_country: "",
	
	/** パスポート発行日*/
	person_pptissue: "",
	
	/** パスポート有効期限*/
	person_pptexp: "",

	/** 性別 */
	person_sex: "",

	/** 旅客区分 */
	person_passenger_code: "",

	/** 生年月日 */
	person_birthday: "",

	/** 年齢 */
	person_age: "",

	/** 郵便番号 */
	person_zip: "",

	/** 住所１*/
	person_add0: "",

	/** 住所２*/
	person_add1: "",

	/** 連絡先区分(0:自宅, 1:会社, 2:携帯)*/
	person_contactflag: "",

	/** 連絡先 */
	person_tel: "",

	/** 緊急連絡先 */
	person_emergencytel: "",

	/** メールアドレス */
	person_email: "",

	/** ※ 現在使用してません ※ お支払い方法 */
	person_shiharai: "",

	/** 当社からのお得情報 */
	person_mailmag: "",

	/** 旅行者が旅行に参加する(0:参加する, 1:参加しない) */
	person_daihyoflag: "",


	/** パスワード */
	person_pass: "",

	/** 秘密の質問 */
	person_himitsu_q: "",

	/** 質問の答え */
	person_himitsu_a: "",

	/** ご質問・ご要望 */
	person_yobo: "",

	/** 集合場所コード */
	person_shugo_code: "",

	/** 集合場所名 */
	person_shugo_name: "",

	/** 保険加入フラグ */
	person_hoken: "",

	/** 保険契約コード */
	person_hoken_code: "",

	/** 
	 * 申込者とは別の代表者
	 * @type {import("./store").PersonDoko}  
	 */
	person_daihyo_data:null,

	/** 
	 * 同行者
	 * @type {import("./store").PersonDoko[]}  
	 */
	person_doko_list:[],

	/** 
	 * 幼児
	 * @type {import("./store").PersonDoko[]}  
	 */
	person_inf_list:[],



	/** BtoB代理店担当者名 */
	agent_name: "",

	/** BtoB代理店連絡先 */
	agent_tel: "",

	/** BtoB代理店メールアドレス */
	agent_mail: "",


	/** クーポンコード */
	coupon: "",

	/** 宿泊ホテル名 */
	hotelname: "",

	/** 獲得予定ポイント */
	get_point: 0,

	/** 利用可能ポイント */
	available_point: 0,

	/** 利用ポイント */
	use_point: 0,

})


/**
 * お客様(代表者、同行者、幼児）クラス
 */
const PersonDoko = extendModel({

	/** お名前（漢字）姓 */
	person_doko_sei: "",

	/** お名前（漢字）名 */
	person_doko_mei: "",

	/** フリガナ（全角）セイ */
	person_doko_kanasei: "",

	/** フリガナ（全角）メイ */
	person_doko_kanamei: "",

	/** ローマ字（半角英字）SEI */
	person_doko_alphasei: "",

	/** ローマ字（半角英字）MEI */
	person_doko_alphamei: "",
	
	/** 旅券番号（半角英数字）*/
	person_doko_passportno: "",
	
	/** パスポート受領予定日*/
	person_pptdate: "",
	
	/** パスポート発行日*/
	person_pptissue: "",
	
	/** パスポート有効期限*/
	person_pptexp: "",
	
	/** 国籍*/
	person_country: "",

	/** 性別 */
	person_doko_sex: "",

	/** 旅客区分 */
	person_doko_passenger_code: "",

	/** 0:大人, 1:小人, 2:幼児 */
	person_doko_passenger_paxtype: "",

	/** 0:通常, 1:添い寝 */
	person_doko_passenger_soineflag: "0",

	/** 生年月日 */
	person_doko_birthday: "",

	/** 年齢 */
	person_doko_age: "",

	/** 同伴者 */
	person_doko_dohan: "",

	/** 集合場所コード */
	person_doko_shugo_code: "",

	/** 集合場所名 */
	person_doko_shugo_name: "",

	/** 保険加入フラグ */
	person_doko_hoken: "",

	/** 保険契約コード */
	person_doko_hoken_code: "",

})


/**
 * お客様(代表者、同行者、幼児）クラス
 */
const Login = extendModel({

	/** 代表者の旅客区分 */
	login_daihyo_passenger_code: "",

	/** 0:申込者が旅行に参加する, 1:申込者は旅行に参加しない */
	login_daihyo_flag: "",

	/** ログインモード（0:会員登録しないで予約, 1:会員登録して予約, 2:ログインして予約）*/
	login_flag: "",

	/** ログインメールアドレス*/
	login_mail: "",

	login_pass: "",

	/** フォルシアJR用 ログイン担当者CD */
	login_charger_code: "",

	/** フォルシアJR用 ログイン担当者名 */
	login_charger_name: "",

})

/**

 * お客様の選択状況
*/
const UserChoose = extendModel({

	/** 出発日 */
	from_date:"",

	/** ツアーコード */
	tour_code:"",

	/** 営業所コード */
	branch_code:"",

	/** 予約済みかどうか */
	is_booking:false,

	/** メールを送信したかどうか */
	is_mail:false,

	/** 予約番号 */
	booking_no:"",

	/** 約款を読んだかどうか */
	is_read_yakkan:false,

	/** 画面上のURL */
	display_url:"",

	/** 決済遷移表示するか(true:表示する, false:表示しない) */
	is_pay_disp:false,

	/** サーバーからの返却メッセーテジ */
	server_message:"",

	/** ツアーの流れURL */
	flow_url:"",

	/** ページコメント */
	page_comment:"",

	/** リクエスト予約をしたか 	true:リクエスト予約 false:通常 */
	is_request:false,

	/** 完了ページ</head>直前 */
	cv_thanks_head:"",

	/** 完了ページ<body>直後(LINEトラベルタグセット場所) */
	cv_thanks_body:"",

	/** TL成功してるか	true:成功 false:失敗 */
	is_tll:true,

	/** デバッグフラグ（販売ステータスを見ない） */
	debug_flag:0,

	/** 戻り先URL（フォルシアJR用） */
	back_url:"",

	
})


/**
 * 検索状態の基底オブジェクト
 * デフォルト値を設定する
 * @description 複製された`{SearchDomState}`は監視対象となります
 */
const SearchState = extendModel({
	/** ヘッダフッタコード */
	header_cd: '',
	/** 代理店コード */
	agent: '',
	/** パンフレットコード */
	pamphletcd: '',
	/** 出発地グループコード */
	dep_grp: '',
	/** 目的地グループコード */
	hmn_grp: '',
	/** こだわり条件グループコード */
	cho_grp: '',
	/** 交通グループコード */
	trf_grp: '',
	/** 旅行期間グループコード */
	tem_grp: '',
	/** 予算グループコード */
	ysn_grp: '',
	/** 利用人数グループコード */
	pax_grp: '',
	/** 出発地1 */
	dep1 : '',
	/** 出発地2 */
	dep2 : '',
	/** 出発地3 */
	dep3 : '',
	/** 出発地4 */
	dep4 : '',
	/** 出発地5 */
	dep5 : '',
	/** 出発地6 */
	dep6 : '',
	homen1 : '',
	homen2 : '',
	homen3 : '',
	homen4 : '',
	homen5 : '',
	homen6 : '',
	homen7 : '',
	homen8 : '',
	homen9 : '',

	tmp_dep3: '',
	tmp_dep4: '',
	tmp_dep5: '',
	tmp_dep6: '',
	tmp_homen4: '',
	tmp_homen5: '',
	tmp_homen6: '',
	tmp_homen7: '',
	tmp_homen8: '',
	tmp_homen9: '',
	/** @type {string|string[]} - 営業所コード */
	branch_cd: [],
	/** @type {string|string[]} - 交通手段 */
	transfer : [],
	/** @type {string|string[]} - 輸送キャリア */
	transport : [],
	/** @type {string|string[]} -こだわり条件グループ */
	choice_group: [],
	/** @type {string|string[]} - こだわり条件 */
	choice: [],
	/**  @type {string|string[]} - 宿泊施設グループ（都市コード） */
	hotel_group: [],
	/** @type {string|string[]} - 宿泊施設 */
	hotel: [],
	/** @type {string} - 目的地のAND演算子フラグ 1:and検索 */
	homen_and : '',
	/** @type {string} - 添乗員 0:なし | 1:あり */
	tcflag : '',
	term : '',
	roompax : '',
	/** 出発日 年月 */
	dep_yymm : '',
	/** 出発日 日 */
	dep_dd : '',

	/** 最小料金 */
	minprice : '',

	/** 最大料金 */
	maxprice : '',

	/** ページ */
	page : 1,

	/** 表示件数 */
	size : 10,

	/** @type {number} 0:新着順 | 1:安い順 | 2:高い順 */
	sort : 0,

	/**
	 * フリーワード
	 * @type {string|string[]}
	 */
	searchkeyword : '',
})
/**
 * 検索状態の基底オブジェクト
 * デフォルト値を設定する
 * @description 複製された`{SearchDomState}`は監視対象となります
 */
const SearchMenu = extendModel({
	/** @type {MSearchMenu.Pax[]} */
	paxMenu: [],
	/** @type {MSearchMenu.Term[]} */
	termMenu: [],
	minpriceMenu: [],
	maxpriceMenu: [],
	/** @type {MSearchMenu.Transfer[]} */
	transferMenu: [],
	/** @type {MSearchMenu.Choice[]} */
	choiceMenu: [],

	depYearMenu: [],
	depMonthMenu: [],
	depDayMenu: [],

	/** @type {AreaType1[]} */
	dep1Menu: [],
	/** @type {AreaType2[]} */
	dep2Menu: [],
	/** @type {AreaType1[]} */
	dep3Menu: [],
	/** @type {AreaType2[]} */
	dep4Menu: [],
	/** @type {AreaType1[]} */
	dep5Menu: [],
	/** @type {AreaType2[]} */
	dep6Menu: [],
	/** @type {AreaType1[]} */
	homen1Menu: [],
	/** @type {AreaType2[]} */
	homen2Menu: [],
	/** @type {AreaType3[]} */
	homen3Menu: [],
	/** @type {AreaType1[]} */
	homen4Menu: [],
	/** @type {AreaType2[]} */
	homen5Menu: [],
	/** @type {AreaType3[]} */
	homen6Menu: [],
	/** @type {AreaType1[]} */
	homen7Menu: [],
	/** @type {AreaType2[]} */
	homen8Menu: [],
	/** @type {AreaType3[]} */
	homen9Menu: [],
})

/** 検索メニュー制御オプション */
const SearchMenuOption = extendModel({
	/** APIパス */
	API_PATH: `${App.CONTEXT_PATH}/api`,
	/** APIパス */
	SEARCH_PATH: `${App.SYSTEM_PATH}/search`,
	/** 画面遷移フラグ */
	goto: true,
	/** 出発地グループコード */
	dep_grp: '',
	/** 目的地グループコード */
	hmn_grp: '',
	/** こだわり条件グループコード */
	cho_grp: '',
	/** 交通グループコード */
	trf_grp: '',
	/** 旅行期間グループコード */
	tem_grp: '',
	/** 予算グループコード */
	ysn_grp: '',
	/** 利用人数グループコード */
	pax_grp: '',
	/** @type {string|string[]} - 営業所コード */
	branch_cd: [],
})



/**
 * BtoB代理店ログインクラス
 */
const AgentLogin = extendModel({

	/** ログインID */
	login_id: "",

	/** ログインPW */
	login_pw: "",

	/** 事業所コード */
	ofc: "",

	/** 営業所コード */
	br: "",

	/** 目的地グループコード */
	grp: "",

	/** 目的地エリアコード */
	hmn: "",

	/** 目的地都道府県コード */
	arr: "",

	/** 交通機関 グループコード */
	t_grp: "",

	/** 交通機関 交通条件コード */
	t_trf: "",

})



/** 検索DOM状態オブジェ(監視対象) */
const SearchDomState = (()=> {
	const state = _.merge({}, SearchState.new(), SearchMenu.new() )
	Libs.deepUnset(state, 'new')
	return mobx.observable( state )
})()

/** jQuery.readyによる共通処理 */
$(()=>
{
	/** ヘッダフッタがあればセッションストレージに保存して、なければセッションストレージから取得する */
	{
		/** @type {string} */
		let headercd = _.get( Libs.urlInfo().param, 'hcd', '' )
		const $header = $('#header')
		const $footer = $('#footer')
		let headerHtml = Libs.trim($header.html())
		let footerHtml = Libs.trim($footer.html())
		let agentcd = _.get( Libs.urlInfo().param, 'agent', '' )	//BtoBtoC用
		let unitcd = _.get( Libs.urlInfo().param, 'unit', '' )		//BtoB用

		/** headerHtmlがあれば */
		if( headerHtml )
		{
			/** セッションストレージに保存 */
			App.permanentSession.setItem('header', {
				code: headercd,
				html: headerHtml
			})
		}
		else
		{
			/** なければセッションストレージから取得 */
			const item = App.permanentSession.getItem('header')
			if ( item )
			{
				$header.html( _.get(item, 'html') )
				if ( !headercd ) headercd = _.get(item, 'code')
			}
		}
	
		/** footerHtmlがあれば */
		if( footerHtml )
		{
			/** セッションストレージに保存 */
			App.permanentSession.setItem('footer', {
				code: headercd,
				html: footerHtml
			})
		}
		else
		{
			/** なければセッションストレージから取得 */
			const item = App.permanentSession.getItem('footer')
			if ( item )
			{
				$footer.html( _.get(item, 'html') )
				if ( !headercd ) headercd = _.get(item, 'code')
			}
		}

		/** BtoBtoC */
		if(agentcd){
			/** セッションストレージに保存 */
			App.permanentSession.setItem('agent', {
				code: agentcd,
			})
		}else{
			/** なければセッションストレージから取得 */
			const item = App.permanentSession.getItem('agent')
			agentcd = _.get(item, 'code')
		}

		/** BtoB */
		if(unitcd){
			/** セッションストレージに保存 */
			App.permanentSession.setItem('unit', {
				code: unitcd,
			})
		}else{
			/** なければセッションストレージから取得 */
			const item = App.permanentSession.getItem('unit')
			unitcd = _.get(item, 'code')
		}

		/** App.data.headercdに保存 */
		if( headercd ) _.set(App.data, 'headercd', headercd)
		if( agentcd ) _.set(App.data, 'agentcd', agentcd)
		if( unitcd ) _.set(App.data, 'unitcd', unitcd)
	}
})

export {
	App,
	pathInfo,
	baseApp,
	extendModel,
	domStateMerge,
	SearchState,
	SearchDomState,
	SearchMenuOption,
	DetailData,
	FavoriteCartData,
	CartData,
	Shohin,
	Passenger,
	RoomPax,
	BinData,
	DepArrData,
	HotelData,
	OtherSetData,
	OtherData,
	TempSearchShohin,
	ShohinImage,
	Person,
	PersonDoko,
	Login,
	UserChoose,
	AgentLogin,
}